'use strict';

var React = require('react'),
    AlertTypes = require('../constants/AlertTypes'),
    SidebarTypes = require('../constants/SidebarTypes'),
    OverlayStore = require('../stores/OverlayStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    OkayAlert = require('../alerts/OkayAlert'),
    ZineLink = require('../atoms/ZineLink'),
    LogOutAlert = require('../alerts/LogOutAlert'),
    SharePostedStampAlert = require('../alerts/SharePostedStampAlert'),
    DeleteDraftAlert = require('../alerts/DeleteDraftAlert'),
    DeleteStampAlert = require('../alerts/DeleteStampAlert'),
    DeleteZineAlert = require('../alerts/DeleteZineAlert'),
    EditorDeleteSectionAlert = require('../alerts/EditorDeleteSectionAlert'),
    EditorDisregardChangesAlert = require('../alerts/EditorDisregardChangesAlert'),
    UserStore = require('../stores/UserStore'),
    Link = require('../atoms/Link'),
    SidebarActionCreators = require('../actions/SidebarActionCreators'),
    { transitionTo, makeHref } = require('../router');

var AlertHost = React.createClass({
  mixins: [createStoreMixin(OverlayStore), PureRenderMixin],

  getStateFromStores() {
    return {
      alert: OverlayStore.getAlert()
    };
  },

  componentDidUpdate(prevProps, prevState) {
    var prevAlertId = prevState && prevState.alert && prevState.alert.id,
        alertId = this.state.alert && this.state.alert.id;

    if (alertId) {
      return;
    }

    switch (prevAlertId) {
    case AlertTypes.SHARE_POSTED_STAMP:
      SidebarActionCreators.showSidebar(SidebarTypes.ADD_STAMP_TO_ZINES, {
        stampId: prevState.alert.stampId
      });
      break;
    case AlertTypes.NOT_FOUND:
      transitionTo('home');
      break;
    }
  },

  render() {
    var alert = this.state.alert;
    if (!alert) {
      return null;
    }

    switch (alert.id) {
    case AlertTypes.SERVER_ERROR:
      return (
        <OkayAlert title='Something went wrong'
                   message={
                     <span>
                      Sorry! We are working to resolve this issue.<br/>
                      Please, try again later.
                     </span>
                   } />
      );
    case AlertTypes.CONNECTION_ERROR:
      return (
        <OkayAlert title='Something went wrong'
                   message='There seems to be a problem with your Internet connection.' />
      );
    case AlertTypes.LOGOUT:
      return <LogOutAlert />;
    case AlertTypes.NOT_FOUND:
      return (
        <OkayAlert title='Not Found'
                   message='We could not find what you were looking for.'
                   buttonText='Go to Home' />
      );
    case AlertTypes.DELETE_DRAFT:
      return <DeleteDraftAlert draftUuid={alert.draftUuid} />;
    case AlertTypes.DELETE_STAMP:
      return <DeleteStampAlert stampId={alert.stampId} />;
    case AlertTypes.DELETE_ZINE:
      return <DeleteZineAlert zineSlug={alert.zineSlug} />;
    case AlertTypes.SHARE_POSTED_STAMP:
      return <SharePostedStampAlert stampId={alert.stampId} />;
    case AlertTypes.EDITOR_DESKTOP_ONLY:
      return (
        <OkayAlert title='Oops'
                   message='Please, use laptop or desktop computer to create a stamp.' />
      );
    case AlertTypes.EDITOR_COVER_TITLE_REQUIRED:
      return <OkayAlert title='Cover image and title are required' />;
    case AlertTypes.EDITOR_COVER_REQUIRED:
      return <OkayAlert title='Cover image is required' />;
    case AlertTypes.EDITOR_TITLE_REQUIRED:
      return <OkayAlert title='Title is required' />;
    case AlertTypes.EDITOR_ADD_MORE_CONTENT:
      return (
        <OkayAlert title='Add content before posting'
                   message='Press “+” button to add more content.' />
      );
    case AlertTypes.EDITOR_DELETE_SECTION:
      return <EditorDeleteSectionAlert sectionId={alert.sectionId} />;
    case AlertTypes.EDITOR_DISREGARD_CHANGES:
      return <EditorDisregardChangesAlert />;
    case AlertTypes.UPLOAD_USER_IMAGE_ERROR:
      return (
        <OkayAlert title='Oops!'
                   message='Something went wrong uploading your image.' />
      );
    case AlertTypes.AUDIO_NOT_FOUND:
      return <OkayAlert title='Audio not found' />;
    case AlertTypes.VIDEO_NOT_FOUND:
      return <OkayAlert title='Video not found' />;
    case AlertTypes.VIDEO_EMBED_FORBIDDEN:
      return (
        <OkayAlert title='Can’t embed this video'
                   message={<span>This video cannot be embedded<br />due to its privacy settings.</span>} />
      );
    case AlertTypes.ZINE_ALREADY_EXISTS:
      return (
        <OkayAlert title='Collection Already Exists'
                   message={
                    <span>
                      Collection called <ZineLink zine={alert.zine} bold /> already exists.
                    </span>
                   } />
      );
    case AlertTypes.ZINE_TITLE_TOO_SHORT:
      return (
        <OkayAlert title='Title Too Short'
                   message='Title should be eight characters minimum.' />
      );
    case AlertTypes.ZINE_TITLE_TWO_WORDS:
      return (
        <OkayAlert title='Title Too Short'
                   message='Title should be two words minimum.' />
      );
    case AlertTypes.ZINE_DESCRIPTION_TOO_SHORT:
      return (
        <OkayAlert title='Description Too Short'
                   message='Description should be 20 characters minimum.' />
      );
    case AlertTypes.STAMP_SAVE_IMAGE_HELP:
      const editorLink = UserStore.isAuthenticated() ?
        <Link to='draftCompose' params={{ stampSegment: 'new' }}>Editor</Link> :
        'Editor';

      return (
        <OkayAlert title='What’s this?'
                   message={
                    <span>
                      This button lets you collect inspiring images to your {editorLink}.
                      <br />
                      <br />
                      Collected images can then be used to create your own moodboards or illustrate stories.
                      <br />
                      <br />
                      All images will come with a credit and a link back to the source. This gives their authors additional exposure.
                    </span>
                   }
                   buttonText='Got it' />
      );
    case AlertTypes.SHARE_DRAFT:
      const draftHref = makeHref('draftPreview', { stampSegment: alert.draftUuid });
      const previewLink = window.location.origin + draftHref;
      const handleClick = (e) => { e.target.select(); };

      return (
        <OkayAlert title='Share Draft'
                   message={
                     <span>
                       Share your draft to get feedback:
                       <br />
                       <br />
                       <input className='FormInput' value={previewLink} readOnly onClick={handleClick} />
                     </span>
                   } />
      );
    default:
      console.warn('Bad alert type', alert);
    }
  }
});

module.exports = AlertHost;



/** WEBPACK FOOTER **
 ** ./hosts/AlertHost.jsx
 **/